"use client";

/**
 * Client-side carrier for two origins that are runtime server config — never
 * NEXT_PUBLIC (see scripts/assert-web-env-agnostic.sh) — mounted once in the
 * root layout like ExperimentsProvider:
 *
 *  - the deployed-app link origin (app.squidler.io), which client components
 *    combine with toDeployedAppLink() to rewrite live-app links out of the PWA
 *    scope. Default "" = links pass through unchanged (static render, dev).
 *  - the site's own origin (APP_BASE_URL), which the chat's markdown renderer
 *    uses to keep links to our own pages in the tab while outbound links open
 *    beside the conversation. Default "" = only relative links count as ours.
 */

import { createContext, useContext, type ReactNode } from "react";

const AppLinkOriginContext = createContext("");
const SiteOriginContext = createContext("");

export function AppLinkOriginProvider({ origin, siteOrigin, children }: {
  origin: string;
  siteOrigin: string;
  children: ReactNode;
}) {
  return (
    <AppLinkOriginContext.Provider value={origin}>
      <SiteOriginContext.Provider value={siteOrigin}>{children}</SiteOriginContext.Provider>
    </AppLinkOriginContext.Provider>
  );
}

export const useAppLinkOrigin = (): string => useContext(AppLinkOriginContext);

/** The app's own origin, for telling our links from outbound ones. */
export const useSiteOrigin = (): string => useContext(SiteOriginContext);
